import {DetailsList, IconButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import ProjectLink from "../Components/ProjectLink";
import EditFinalization from "../Panel/Transaction/EditFinalization";
import {MoneyField} from "../Utilities/MoneyField";

function Finalization(props) {
    const [user] = useContext(AuthContext);
    const [projects, setProjects] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/finalization`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => setProjects(data))
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [params.id, refresh, user.token]);

    const [editFinalization, setEditFinalization] = useState(false);

    const columns = [
        {
            key: 'name',
            name: 'Projekt',
            ariaLabel: 'Nazwa utworzonego projektu',
            fieldName: 'name',
            minWidth: 200,
            isRowHeader: true,
            isResizable: false,
            onRender: ProjectLink
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 160,
            isResizable: true,
        },
        {
            key: 'left',
            name: 'Płatności',
            ariaLabel: 'Wartość pozostałych płatności',
            fieldName: 'left',
            minWidth: 160,
            isResizable: true,
            ...MoneyField()
        },
        {
            key: 'person',
            name: 'Kupujący',
            ariaLabel: 'Kupujący',
            fieldName: 'person',
            minWidth: 160,
            isResizable: true,
        },
        {
            key: 'phone',
            name: 'Telefon',
            ariaLabel: 'Telefon',
            fieldName: 'phone',
            minWidth: 160,
            isResizable: true,
        },
        {
            key: 'email',
            name: 'Email',
            ariaLabel: 'Email',
            fieldName: 'email',
            minWidth: 160,
            isResizable: true,
        },
        {
            key: 'transfer_date',
            name: 'Odbiór',
            ariaLabel: 'Data odbioru',
            fieldName: 'transfer_date',
            minWidth: 160,
            isResizable: true,
        },
        {
            key: 'edit',
            name: 'Edycja',
            ariaLabel: 'Edycja',
            fieldName: 'edit',
            minWidth: 60,
            isResizable: false,
            onRender: (item) => <IconButton iconProps={{iconName: 'Edit'}} onClick={() => setEditFinalization(item)} />
        }
    ];
    return (
        <AppContent title={'Odbiory'} backTo={'/'}>
            <DetailsList items={projects} columns={columns} selectionMode={SelectionMode.none}/>
            <EditFinalization edit={editFinalization} dismissPanel={() => setEditFinalization(false)} onSuccess={() => setRefresh(refresh + 1)} />
        </AppContent>
    );
}
export default Finalization;